<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BoXJK3/images/cover.jpg?1733067611620" alt="This image is the cover for the book Round Fabric Art Bowls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Round Fabric Art Bowls
      </h1>
      <p class="bookDescription body article font2">
        <p>Craft fabric bowls with ease Perfect for display or gift-giving, modern, functional artisan fabric bowls are deceptively simple to make. The artisan fabric bowl projects are a few common tools and a (reusable) template away — you won't want to stop at just one! While you can whip up the projects on your sewing machine for a fast, easy home decor project, you can also enjoy the tranquility of hand-sewing artisan bowls. In Round Fabric Art Bowls, you'll learn everything you need to know to construct fabric bowls, from adjusting the bowl size to choosing fabrics.  Six 18" bowl projects feature machine sewing and piecing, modified paper piecing, applique, hand sewing, English Paper Piecing, and more for eye-catching results Apply common quilting techniques, decorative sewing, and fabric manipulation to elevate your fabric art bowls Making fabric bowls is addictive and deceptively simple, and alongside Kirsten Fisher’s previous book, Modern Fabric Art Bowls, you can create a stunning gallery of bowls to display and gift</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kirsten Fisher
      </h2>
      
      <p class="authorDescription body article">Kirsten Fisher has taught quilting and bowl making for over ten years. She is a member and former co-president of The Brooklyn Quilters Guild and a member of The Textile Study Group of New York. She works and lives in Brooklyn, NY. kirstenfisher.net</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Published by C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04b739fd